import { useState, useEffect } from 'react'

const useVersion = () => {
  const [version, setVersion] = useState('1.24.01')

  useEffect(() => {
    // 尝试从多个来源获取版本号
    const getVersion = async () => {
      try {
        // 首先尝试从 API 获取版本号
        const response = await fetch('/api/version')
        if (response.ok) {
          const data = await response.json()
          setVersion(data.version)
          return
        }
      } catch (error) {
        console.log('无法从 API 获取版本号，使用默认版本')
      }

      try {
        // 如果 API 失败，尝试从 package.json 获取
        const packageResponse = await fetch('/package.json')
        if (packageResponse.ok) {
          const packageData = await packageResponse.json()
          setVersion(packageData.version)
          return
        }
      } catch (error) {
        console.log('无法从 package.json 获取版本号')
      }

      // 如果都失败了，使用默认版本号
      setVersion('1.24.01')
    }

    getVersion()
  }, [])

  return version
}

export default useVersion
